import { PERM } from '@/constants/permissions';

export type NavItem = { name: string; href: string; icon: string; permission: string };

/**
 * Ordered top-level nav. Order matters beyond display: it's also the
 * priority order used to pick a landing page for a user who lacks
 * Dashboard access (see DefaultLandingRoute).
 */
export const NAV: ReadonlyArray<NavItem> = [
  { name: 'Dashboard',   href: '/',             icon: '📊',  permission: PERM.DASHBOARD_READ },
  { name: 'Restaurants', href: '/restaurants',  icon: '🏪',  permission: PERM.RESTAURANT_READ },
  { name: 'Groups',      href: '/groups',       icon: '🏢',  permission: PERM.GROUP_READ },
  { name: 'Reports',     href: '/reports/sales', icon: '📈', permission: PERM.REPORT_READ },
  { name: 'Sync',        href: '/sync',         icon: '🔄',  permission: PERM.SYNC_READ },
  { name: 'Users',       href: '/users',        icon: '👥',  permission: PERM.USER_READ },
  { name: 'Roles',       href: '/roles',        icon: '🛡️', permission: PERM.ROLE_READ },
  { name: 'Audit',       href: '/audit',        icon: '📋',  permission: PERM.AUDIT_READ },
  { name: 'POS Errors',  href: '/errors',       icon: '🐞',  permission: PERM.ERRORS_READ },
  { name: 'Billing',     href: '/billing',      icon: '💳',  permission: PERM.BILLING_READ },
];
